import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  Row,
  Col,
  InputGroup,
  FormText,
  Card,
  Table,
} from "react-bootstrap";
import { TERMS } from "../../constant/_constant";
import {
  IconFileDescription,
  IconLabel,
  IconArticle,
  IconUser,
  IconMail,
  IconPhone,
  IconTruck,
  IconFileText,
  IconReceipt,
  IconHomeSpark,
  IconCurrencyDollar,
} from "@tabler/icons-react";
import { useFormContext, Controller } from "react-hook-form";
import { API_ENDPOINTS } from "../../constant/_constant";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import useDebounce from "../../hooks/useDebounce";
import usePostRequest from "../../hooks/usePostRequest";

function ShippingDetails({ initialVal }) {
  const {
    control,
    watch,
    register,
    setValue,
    formState: { errors },
  } = useFormContext();

  const [searchDebounce, setSearchDebounce] = useState({
    searchName: "",
    searchEmail: "",
  });
  const suppressAutoUpdate = useRef(false);

  const { debounceSearch } = useDebounce();
  const sameShipNameasKO = watch("sameShipNameasKO");
  const sameBillNameasKO = watch("sameBillNameasKO");
  const contractOfficerName = watch("contractOfficerName");
  const contractOfficerEmail = watch("contractOfficerEmail");
  const contractOfficerAddress = watch("contractOfficerAddress", "");
  const contractOfficerPhone = watch("contractOfficerPhone");
  const selectedBySuggestion = watch("selectedBySuggestion");
  const [suggestion, setSuggestion] = useState([]);

  useEffect(() => {
    // if (suppressAutoUpdate.current) return;
    // if (selectedBySuggestion) return
    const updateShippingDetails = () => {
      if (sameShipNameasKO === true) {
        setValue("shippingCustomerName", contractOfficerName);
        setValue("shippingCustomerAddress", contractOfficerAddress);
        setValue("shippingCustomerEmail", contractOfficerEmail);
        setValue("shippingCustomerPhone", contractOfficerPhone);
      } else if (initialVal === 0 && sameShipNameasKO === false) {
        setValue("shippingCustomerName", "");
        setValue("shippingCustomerAddress", "");
        setValue("shippingCustomerEmail", "");
        setValue("shippingCustomerPhone", "");
      }
    };

    updateShippingDetails();
  }, [
    sameShipNameasKO,
    // sameBillNameasKO,
    // contractOfficerName,
    // contractOfficerEmail,
    // contractOfficerAddress,
    // contractOfficerPhone,
    setValue,
  ]);

  const textareaRef = useRef(null);

  const address = watch("shippingCustomerAddress");
  const BillingAddress = watch("BillingCustomerAddress");

  const handleResize = (textarea) => {
    // console.log("textarea", textarea);
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  useEffect(() => {
    handleResize(textareaRef.current);
  }, [address]);

  useEffect(() => {
    handleResize(textareaRef.current);
  }, [BillingAddress]);

  const {
    data: fetchdata,
    isLoading,
    postData: fetchRfq,
  } = usePostRequest(API_ENDPOINTS.GET_CUSTOMER_AUTOFILL);

  const prependCountryCodeIfMissing = (phoneNumber) => {
    if (!phoneNumber) return phoneNumber;
    const trimmed = phoneNumber.trim();
    if (trimmed.startsWith("+")) {
      return trimmed;
    }
    return "+1" + trimmed;
  };

  const handleSelect = (item) => {
    suppressAutoUpdate.current = true;

    setValue("selectedBySuggestion", true);
    setValue("sameShipNameasKO", false);

    setValue(
      "contractOfficerName",
      `${item.first_name || ""} ${item.last_name || ""}`
    );
    setValue(
      "contractOfficerEmail",
      item?.primary_email ? item.primary_email.Address : ""
    );
    setValue(
      "contractOfficerPhone",
      prependCountryCodeIfMissing(item?.primary_phone?.FreeFormNumber || "")
    );
    // setValue(
    //   "contractOfficerPhone",
    //   item?.primary_phone ? item.primary_phone.FreeFormNumber : ""
    // );
    setValue("contractOfficerAddress", item.address);

    setValue("shippingCustomerName", item?.shipping_name);
    setValue("shippingCustomerEmail", item?.shipping_email);
    setValue(
      "shippingCustomerPhone",
      prependCountryCodeIfMissing(item?.shipping_phone || "")
    );
    // setValue("shippingCustomerPhone", item?.shipping_phone);

    if (item?.shipping_address) {
      const address = item.shipping_address;
      const formattedAddress = `${address.Line1 || ""}
    ${address.Line2 || ""}
    ${address.City || ""}, ${address.CountrySubDivisionCode || ""} ${
        address.PostalCode || ""
      }
    ${address.Country || ""}`;
      setValue("shippingCustomerAddress", formattedAddress);
    }

    setSuggestion(null);
  };

  const handleSearchByName = (e) => {
    setValue("contractOfficerName", e.target.value);
    setSearchDebounce({ searchName: e.target.value });
  };
  const handleSearchByEmail = (e) => {
    setValue("contractOfficerEmail", e.target.value);
    setSearchDebounce({ searchEmail: e.target.value });
  };

  const onSuccessData = (data) => {
    setSuggestion(data);
  };

  useEffect(() => {
    if (
      searchDebounce?.searchEmail?.length > 0 ||
      searchDebounce?.searchName?.length > 0
    ) {
      fetchRfq(
        {
          email:
            searchDebounce?.searchEmail?.length > 0
              ? searchDebounce?.searchEmail
              : undefined,
          first_name:
            searchDebounce?.searchName?.length > 0
              ? searchDebounce?.searchName
              : undefined,
          module_type: "ORDER",
        },
        onSuccessData
      );
    }
  }, [debounceSearch, searchDebounce]);

  // useEffect(() => {
  //   handleResize();
  // }, [address]);

  // useEffect(() => {
  //   handleResize();
  // }, []);

  return (
    <>
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="">Shipping Method</Form.Label>
            <InputGroup>
              <Form.Select {...register("shipping_method")}>
                <option value={""}>Select a method</option>
                <option value={"UPS"}>UPS</option>
                <option value={"FedEx"}>FedEx</option>
                <option value={"Freight"}>Freight</option>
                <option value={"Other"}>Other</option>
              </Form.Select>
            </InputGroup>
            {errors.shipping_method && (
              <span className="text-danger">
                {errors.shipping_method.message}
              </span>
            )}
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Tracking Number</Form.Label>
            <InputGroup>
              <Form.Control
                type="text"
                {...register("trackingID")}
                placeholder="Enter Tracking Number"
              />
            </InputGroup>
            {errors.trackingID && (
              <span className="text-danger">{errors.trackingID.message}</span>
            )}
          </Form.Group>
        </Col>
      </Row>

      <Row>
        {["Freight", "Other"].includes(watch("shipping_method")) && (
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label className="">
                {watch("shipping_method") === "Freight"
                  ? "Freight Shipping Details"
                  : "Other Shipping Details"}
              </Form.Label>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder={`Enter ${watch("shipping_method")} details`}
                  {...register("shipping_method_detail", {
                    required: "Shipping method details are required",
                  })}
                />
              </InputGroup>
              {errors.shipping_method_detail && (
                <span className="text-danger">
                  {errors.shipping_method_detail.message}
                </span>
              )}
            </Form.Group>
          </Col>
        )}
      </Row>
      <Card className="mb-3 card_suggestion">
        <Card.Header className="card_header">
          <IconFileDescription /> Customer Details
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label className="required">Full name</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconUser stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    {...register("contractOfficerName")}
                    onChange={handleSearchByName}
                    placeholder="Enter Full Name"
                  />
                </InputGroup>
                <div>
                  {((suggestion?.data?.length > 0 &&
                    searchDebounce?.searchName?.length > 0) ||
                    searchDebounce?.searchEmail?.length > 0) && (
                    <div className="suggestions_box">
                      <div className="table-responsive">
                        <Table>
                          <tbody>
                            {suggestion?.data?.map((item, index) => (
                              <tr
                                key={index}
                                onClick={() => handleSelect(item)}
                                style={{ cursor: "pointer" }}
                              >
                                <td>{item?.display_name}</td>
                                <td>{`${item?.first_name || ""} ${
                                  item?.last_name || ""
                                }`}</td>
                                <td>
                                  {item?.primary_email
                                    ? item.primary_email?.Address
                                    : null}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  )}
                </div>
                {errors.contractOfficerName && (
                  <span className="text-danger">
                    {errors.contractOfficerName.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label className="required">Email</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconMail stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    {...register("contractOfficerEmail")}
                    onChange={handleSearchByEmail}
                    type="email"
                    placeholder="Enter Email"
                  />
                </InputGroup>
                {errors.contractOfficerEmail && (
                  <span className="text-danger">
                    {errors.contractOfficerEmail.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label className="required">Phone</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconPhone stroke={1} />
                  </InputGroup.Text>
                  <Controller
                    name="contractOfficerPhone"
                    control={control}
                    rules={{
                      required: "Phone number is required",
                      validate: (value) =>
                        (value && value.length > 0) || "Invalid phone number",
                    }}
                    render={({ field }) => (
                      <PhoneInput
                        className="form-control"
                        {...field}
                        defaultCountry="US"
                        countryCallingCodeEditable={false}
                        international
                        placeholder="Enter phone number"
                        onChange={field.onChange}
                      />
                    )}
                  />
                </InputGroup>
                {errors.contractOfficerPhone && (
                  <span className="text-danger">
                    {errors.contractOfficerPhone.message}
                  </span>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label className="required">Address</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconHomeSpark stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    as="textarea"
                    {...register("contractOfficerAddress")}
                    style={{
                      height: "auto",
                      minHeight: "80px",
                      resize: "none",
                    }}
                    onInput={(e) => {
                      e.target.style.height = "auto";
                      e.target.style.height = `${e.target.scrollHeight}px`;
                    }}
                    placeholder="Enter Address"
                  />
                </InputGroup>
                {errors.contractOfficerAddress && (
                  <span className="text-danger">
                    {errors.contractOfficerAddress.message}
                  </span>
                )}
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="mb-3">
        <Card.Header className="card_header">
          <IconTruck /> Shipping Details
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Full name</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconUser stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    {...register("shippingCustomerName")}
                    type="text"
                    placeholder="Enter Full Name"
                  />
                </InputGroup>
                {errors.shippingCustomerName && (
                  <span className="text-danger">
                    {errors.shippingCustomerName.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconMail stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    {...register("shippingCustomerEmail")}
                    type="email"
                    placeholder="Enter Email"
                  />
                </InputGroup>
                {errors.shippingCustomerEmail && (
                  <span className="text-danger">
                    {errors.shippingCustomerEmail.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconPhone stroke={1} />
                  </InputGroup.Text>
                  <Controller
                    name="shippingCustomerPhone"
                    control={control}
                    rules={{
                      required: "Phone number is required",
                      validate: (value) =>
                        (value && value.length > 0) || "Invalid phone number",
                    }}
                    render={({ field }) => (
                      <PhoneInput
                        className="form-control"
                        {...field}
                        defaultCountry="US"
                        countryCallingCodeEditable={false}
                        international
                        placeholder="Enter phone number"
                        onChange={field.onChange}
                      />
                    )}
                  />
                </InputGroup>
                {errors.shippingCustomerPhone && (
                  <span className="text-danger">
                    {errors.shippingCustomerPhone.message}
                  </span>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconHomeSpark stroke={1} />
                  </InputGroup.Text>
                  <Controller
                    name="shippingCustomerAddress"
                    control={control}
                    defaultValue={address}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                        as="textarea"
                        style={{
                          height: "auto",
                          minHeight: "80px",
                          resize: "none",
                        }}
                        onInput={(e) => {
                          e.target.style.height = "auto";
                          e.target.style.height = `${e.target.scrollHeight}px`;
                        }}
                        placeholder="Enter Address"
                      />
                    )}
                  />
                </InputGroup>
                {errors.shippingCustomerAddress && (
                  <span className="text-danger">
                    {errors.shippingCustomerAddress.message}
                  </span>
                )}
                <div className="d-flex gap-3 align-items-center">
                  <Form.Text className="ko_button d-flex gap-2 pt-2">
                    <Form.Check
                      className="ko_fill_link"
                      type="checkbox"
                      id="sameShipNameasKO"
                      label="Fill with Customer’s information "
                      {...register("sameShipNameasKO")}
                    />
                  </Form.Text>
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
}

export default ShippingDetails;
